// Lib
import React from 'react';
import PropTypes from 'prop-types';

// Roma
import { FormText } from '@milanote/roma';

// Utils
import { useErrorTranslator } from '../../../utils/errorTranslation';

const PrimaryErrorMessage = ({ message, error, align = 'center' }) => {
    const translateError = useErrorTranslator();

    // Prioritize error object over message string
    const displayMessage = error ? translateError(error) : message;

    if (!displayMessage) return null;

    return (
        <FormText color="error" align={align} size="md">
            {displayMessage}
        </FormText>
    );
};

PrimaryErrorMessage.propTypes = {
    message: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    error: PropTypes.object,
    align: PropTypes.oneOf(['left', 'center', 'right']),
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

export default PrimaryErrorMessage;
